import React from 'react';
import { Typography } from '@mui/material';
import { safeFormatDate } from '../../../shared';

const STAMP_OPTS: Intl.DateTimeFormatOptions = {
  month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit',
};

/** The actual timestamp ("Jun 11, 14:32"), shared by the Event Explorer and
 *  Action Log tables so their time columns read alike. */
const TimeCell: React.FC<{ iso: string }> = ({ iso }) => (
  <Typography component="span" variant="body2" noWrap sx={{ whiteSpace: 'nowrap' }}>
    {safeFormatDate(iso, STAMP_OPTS)}
  </Typography>
);

export default TimeCell;
